import * as React from 'react';
import { RecordData } from '../../hooks/data-hooks';
import { RecordDataErrorIndicator } from '../RecordDataErrorIndicator';
import { RecordDataLoadingIndicator } from '../RecordDataLoadingIndicator';
import { RecordDataNotFoundIndicator } from '../RecordDataNotFoundIndicator';
import { Icon } from '../../lib/icons';

export const RecordDataIndicators: React.FC<{
    errorMessage: string;
    notFoundIcon: Icon;
    notFoundMessage: string;
    recordData: RecordData;
}> = (props) => (
    <>
        <RecordDataErrorIndicator recordData={props.recordData} message={props.errorMessage} />
        <RecordDataLoadingIndicator recordData={props.recordData} />
        <RecordDataNotFoundIndicator
            recordData={props.recordData}
            message={props.notFoundMessage}
            icon={props.notFoundIcon}
        />
    </>
);
